import car from "../assets/car-img-invoice.png";

const invoiceData = {
  invoiceNumber: "#0123456",
  contact: {
    phone: "+048 254 567 890",
    id: "183-03X (SEDA UI)",
    location: "KYOTO, JAPAN",
    website: "WWW.BRANDNAME.COM",
  },
  items: [
    {
      description: "SERVICE NAME",
      details:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      qty: 1,
      price: 100.0,
      total: 100.0,
    },
    {
      description: "SERVICE NAME",
      details:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      qty: 2,
      price: 50.0,
      total: 100.0,
    },
    {
      description: "SERVICE NAME",
      details:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      qty: 1,
      price: 100.0,
      total: 100.0,
    },
  ],
  totals: {
    subtotal: 300.0,
    tax: 15.0,
    grandTotal: 315.0,
  },
  signature: {
    name: "John E.",
    title: "Engineer",
    website: "www.yourwebsite.com",
  },
};

const Invoice = () => {
  return (
    <div
      className="container rounded"
      style={{
        backgroundColor: "#ffff",
        padding: "10px",
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div className="row justify-content-center ">
        <div className="col-12 col-md-10 col-lg-12">
          {/* Header Section */}
          <div
            style={{
              background: "linear-gradient(to right, #4b0082, #8a2be2)",
              height: "150px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderTopLeftRadius: "10px",
              borderTopRightRadius: "10px",
            }}
          >
            <img
              // src="https://via.placeholder.com/300x80?text=Header+Illustration"
              src={car}
              alt="Header"
              style={{ maxWidth: "250px", height: "auto" }}
            />
          </div>

          {/* Invoice Body */}
          <div
            className="bg-white"
            style={{
              borderBottomLeftRadius: "10px",
              borderBottomRightRadius: "10px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              padding: "50px",
            }}
          >
            <div className="d-flex justify-content-between align-items-start">
              <div>
                <h2
                  style={{
                    fontWeight: "bold",
                    color: "#333",
                    fontSize: "28px",
                    margin: 0,
                  }}
                >
                  INVOICE
                </h2>
                <p style={{ color: "#666", fontSize: "14px", margin: 0 ,marginBottom:"20px"}}>
                  No. {invoiceData.invoiceNumber}
                </p>
              </div>
              <div
                style={{ textAlign: "right", fontSize: "12px", color: "#666" }}
              >
                <p style={{ margin: 0 }}>{invoiceData.contact.phone}</p>
                <p style={{ margin: 0 }}>{invoiceData.contact.id}</p>
                <p style={{ margin: 0 }}>{invoiceData.contact.location}</p>
                <p style={{ margin: 0 }}>{invoiceData.contact.website}</p>
              </div>
            </div>

            {/* Table Section */}
            <table
              className=""
              style={{ borderColor: "#dee2e6" }}
            >
              <thead>
                <tr
                  style={{
                    backgroundColor: "#f8f9fa",
                    fontSize: "14px",
                    color: "#333",
                    fontWeight: "bold",
                  }}
                >
                  <th style={{ padding: "10px" }}>DESCRIPTION</th>
                  <th style={{ padding: "10px" }}>QTY</th>
                  <th style={{ padding: "10px" }}>PRICE</th>
                  <th style={{ padding: "10px" }}>TOTAL</th>
                </tr>
              </thead>
              <tbody>
                {invoiceData.items.map((item, index) => (
                  <tr key={index} style={{ fontSize: "14px", color: "#333" }}>
                    <td style={{ padding: "10px" }}>
                      <strong>
                        #0{index + 1} {item.description}
                      </strong>
                      <p style={{ fontSize: "12px", color: "#666", margin: 0 }}>
                        {item.details}
                      </p>
                    </td>
                    <td style={{ padding: "10px", verticalAlign: "middle" }}>
                      {item.qty}
                    </td>
                    <td style={{ padding: "10px", verticalAlign: "middle" }}>
                      ${item.price.toFixed(2)}
                    </td>
                    <td style={{ padding: "10px", verticalAlign: "middle" }}>
                      ${item.total.toFixed(2)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {/* Totals Section */}
            <div className="d-flex justify-content-end">
              <div
                style={{ textAlign: "right", fontSize: "14px", color: "#333" }}
              >
                <p style={{ margin: "5px 0" }}>
                  <strong>SUB TOTAL</strong> &nbsp;&nbsp; $
                  {invoiceData.totals.subtotal.toFixed(2)}
                </p>
                <p style={{ margin: "5px 0" }}>
                  <strong>TAX</strong> &nbsp;&nbsp; $
                  {invoiceData.totals.tax.toFixed(2)}
                </p>
                <p style={{ margin: "5px 0", fontWeight: "bold" }}>
                  <strong>GRAND TOTAL</strong> &nbsp;&nbsp; $
                  {invoiceData.totals.grandTotal.toFixed(2)}
                </p>
              </div>
            </div>

            {/* Signature Section */}
            {/* <div className="d-flex justify-content-between align-items-center mt-5">
              <div>
                <div
                  style={{
                    width: "100px",
                    height: "40px",
                    background:
                      "url(https://via.placeholder.com/100x40?text=Signature) no-repeat center",
                    backgroundSize: "contain",
                  }}
                ></div>
                <p style={{ margin: 0, color: "#666", fontSize: "14px" }}>
                  {invoiceData.signature.name}
                </p>
                <p
                  style={{
                    margin: 0,
                    color: "#666",
                    fontSize: " studenti 14px",
                  }}
                >
                  / {invoiceData.signature.title}
                </p>
              </div>
              <p style={{ margin: 0, color: "#666", fontSize: "14px" }}>
                {invoiceData.signature.website}
              </p>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Invoice;
